'use strict'

import angular from 'angular'
import ModelController from './model.controller'

export default angular.module('updateServerApp.myscripts.model', [])
  .controller('MyScriptsModelController', ModelController)
  .name



// WEBPACK FOOTER //
// ./client/app/myscripts/model/index.js